import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { equipmentKeys } from '@/lib/queryKeys';
import type {
  EquipmentDescriptionFilters,
  EquipmentDescriptionListResponse,
} from '@/types/equipment-description';

/** Search each covered category on the server so unrelated types cannot crowd out matches. */
export function useEquipmentDescriptionOptions(
  categories: string[],
  filters: Pick<EquipmentDescriptionFilters, 'status' | 'search' | 'unlinkedOnly' | 'limit'>,
  enabled: boolean,
) {
  const keys = [...new Set(categories.map((category) => category.trim()).filter(Boolean))].sort();
  return useApiQuery({
    queryKey: [...equipmentKeys.all(), 'description-options', keys, filters],
    enabled,
    queryFn: async ({ signal }) => {
      const pages = await Promise.all(
        keys.map((category) =>
          apiGet<EquipmentDescriptionListResponse>(operationsClient, '/equipment-descriptions', {
            params: { ...filters, category },
            signal,
          }),
        ),
      );
      return pages.flatMap((page) => page.items);
    },
  });
}
